import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/pause/Nav";
import { EventBanner } from "@/components/pause/EventBanner";
import { Hero } from "@/components/pause/Hero";
import { Marquee } from "@/components/pause/Marquee";
import { About } from "@/components/pause/About";
import { Nisha } from "@/components/pause/Nisha";
import { Offerings } from "@/components/pause/Offerings";
import { Retreat } from "@/components/pause/Retreat";
import { Events } from "@/components/pause/Events";
import { Waitlist } from "@/components/pause/Waitlist";
import { Faq } from "@/components/pause/Faq";
import { Footer } from "@/components/pause/Footer";
import { WhatsAppFloat } from "@/components/pause/WhatsAppFloat";

export default function Landing() {
  useLenis();

  return (
    <main data-testid="landing-page" className="bg-[#FAF7F2] overflow-x-hidden">
      <EventBanner />
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Nisha />
      <Offerings />
      <Retreat />
      <Events />
      <Waitlist />
      <Faq />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
